<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:13:36
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
    <div style="padding: 20px 0px 0px 20px;">
  
        <el-form style="display: flex;flex-wrap: wrap;" label-width="120px">

              <el-form-item label="教师姓名:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择教师" v-model="input3" style="width: 100%" clearable filterable>
                      <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="职级:" style="display: flex;width: 33%;">
                <el-cascader clearable style="width: 100%;" v-model="input10" :options="classTypsArr11" :props="cascaderprops"></el-cascader>
              </el-form-item>

              <el-form-item label="学科:" style="display: flex;width: 33%;">
                <el-select v-model="input66" style="width:100%;" placeholder="请选择学科" filterable multiple>
                     <el-option v-for="item in subjectArr" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="学科组:" style="display: flex;width: 33%;">
                <el-select v-model="input6" style="width:100%;" placeholder="请选择学科组" filterable >
                     <el-option v-for="item in classTypsArr1" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="入职日期:" style="width: 33%; display: flex;" >
                  <el-date-picker  v-model="dateTime"  type="daterange"   placeholder="选择入职日期"  value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期"   end-placeholder="结束日期" >  </el-date-picker>
              </el-form-item>

           
              <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>
  
        </el-form>
  
  
          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="600">
              <el-table-column prop="realname" label="教师" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #2784e5;" @click="highlightRow(scope.row.id,scope.$index)">  {{ scope.row.realname}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if=" scope.row.sex === 1"> 男 </span>
                    <span v-if=" scope.row.sex === 2"> 女 </span>
                </template>
              </el-table-column>
              <el-table-column prop="rankName" label="职级" show-overflow-tooltip></el-table-column>
              <el-table-column prop="deptName" label="学科组" show-overflow-tooltip></el-table-column>
              <el-table-column prop="teachName" label="学科" show-overflow-tooltip></el-table-column>
              <el-table-column prop="readingNum" label="在读学生" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column prop="classDate" label="停课学生" show-overflow-tooltip></el-table-column> -->
              <el-table-column prop="completeNum" label="结业学生" show-overflow-tooltip></el-table-column>
              <el-table-column prop="leaveNum" label="流失学生" show-overflow-tooltip></el-table-column>
              <el-table-column prop="formalTrainingDate" label="入职日期" show-overflow-tooltip width="150"></el-table-column>
          </el-table>
  
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>




  
  
    </div>
  </template>
  
  
  <script>
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { handleStudent, handleTeacher } from "../utils/publicInterface";
  import { getStudentsType } from "@/api/fiveClassApi"
  import { getTeachers } from "@/api/fiveClassApi"
  import { ApiGetStudentList, } from "@/api/apiTask";
  import { getSubject } from "@/api/fiveClassApi"

  export default {
    components:{
  
    },
    data() {
        return{

            cascaderprops: { value: 'id', label: 'salaryPlanName', children: 'teacherRankList' },
            input10:[],
            dateTime:[],
  
            options:[],
            options1:[{id:1,realname:'初级老师'},{id:2,realname:'中级老师'},{id:3,realname:'高级老师'},{id:4,realname:'特级老师'}],
            options2:[{id:1,realname:'待审批'},{id:2,realname:'审批中'},{id:3,realname:'驳回'},{id:4,realname:'已完成'}],
  
            input1:'',
            input2:'',
            input3:'',
            dataList:[],
  
            pageNum: 1,
            pageSize: 10,
            total: 0,
  
            form:{
                input1:'',
                input2:true,
                input3:'',
            },
  
            titleDialogShowvisible:false,
            titleDialogShowvisible1:false,
            textareainput:'',
  
            fromlabel:'',
            placeholderfrom:'',
            titleDialogShowvisibletitle1:'',
            
            optionsListt:[],
            getStudentsArr_s:[],
            subjectArr:[],

            input4:'',
            input5:'',
            input6:'',

            classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
            classTypsArr1:[],
            classTypsArr11:[],

            input66:[],
            classTypsArr1111:[]   

        }
    },
  
    mounted(){
      getTeachers().then(res => {  this.options = res.data })
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.optionsListt = res.data.data})
      ApiGetStudentList().then((res) => {  let { data } = res; this.getStudentsArr_s = data;  });
      axios.post(`${apiBaseUrl}/teacherRank/findList`, {},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
        if(res.data.code == 200) {
            this.classTypsArr11 = res.data.data
        }else {
            this.$message.error(res.data.message);
            this.classTypsArr11 =  []
          }
      }).catch(err => {
            this.classTypsArr11 =  []
      });
      axios.get(`${ apiBaseUrl }/organizational/getDeptInfoSon`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.classTypsArr1 = res.data.data})

      // getSubject().then(res => {   this.subjectArr = res.data   })
      axios.get(`${ apiBaseUrl }/schedule/teacherCategorylist`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
        this.subjectArr = res.data.data
      })

      this.getApiList()
    },
  
  
    methods:{

        highlightRow (id,index) {
            this.$router.push({
                name: '在职教师详情', 
                params: { id, } 
            })
        },


        getApiList(){
            let data = {
                pageNo: this.pageNum,
                pageSize: this.pageSize,
                formalTrainingDateStart: this.dateTime.length > 0 ? this.dateTime[0] : '',
                formalTrainingDateEnd: this.dateTime.length > 0 ? this.dateTime[1] : '',
                id: this.input3,
                deptId: this.input6,
                rankId:this.input10 && this.input10.length > 0 ? this.input10[this.input10.length - 1] : '',
                teach: this.input66.length > 0 ? JSON.stringify(this.input66) : '',
            }
            axios.post(`${apiBaseUrl}/teacher/findJobTeacher`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
  
                  if(res.data.code === 200){
  
                    let data = res.data.data
                    this.dataList = data.list
                    // this.pageNum = data.current ? data.pageIndex : 0
                    // this.pageSize = data.size ? data.size : 10
                    this.total = data.allTotal
  
                    this.$message({ message: res.data.message , type: "success" })
                  }else{
                    this.dataList = []
                    this.total = 0
                    this.$message({ message: res.data.message , type: "error" })
                  }
            }).catch((err)=>{
                this.dataList= []
                this.pageSize = 10
                this.pageNum = 1
                this.total = 0
                this.$message({ message: err , type: "error" })
            })
        },
  
  
        titlerejectDialogShowClr(){
          this.titleDialogShowvisible = false
        },
  
        titlerejectDialogShowClr1(){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        },
  
        titlerejectDialogShowSubt1(){
          if(this.textareainput){
            this.textareainput = ''
            this.titleDialogShowvisible1 = false
          }else{
            this.$message({ message: '请填写备注~' , type: "warning" })
          }
        },
  
        searchBtns(){
            this.getApiList()
        },

        exportBtns(){
            let data = {
                pageNo: this.pageNum,
                pageSize: this.pageSize,
                formalTrainingDateStart: this.dateTime.length > 0 ? this.dateTime[0] : '',
                formalTrainingDateEnd: this.dateTime.length > 0 ? this.dateTime[1] : '',
                realname: this.input3,
                deptId: this.input6,
                teach: this.input66.length > 0 ? JSON.stringify(this.input66) : '',
            }
            axios.post(`${apiBaseUrl}/teacher/exportJobTeacher`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "在职教师.xlsx"; 
                    downloadLink.click();
                    this.$message({ message: res.data.message , type: "success" })
                }
                else{
                    this.$message({ message: res.data.message , type: "error" })
                }
            })
        },
  
        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''
            this.input66 = []
            this.input10 = []
            this.dateTime = []
            this.pageNum = 1
            this.pageSize = 10
            this.getApiList()
        },
  
        handleSizeChange(e){
            this.pageSize = e
            this.getApiList()
        },
  
        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },
  
        handleClickView(type,itme){
          console.log(itme)
          if(type === 2){
            this.titleDialogShowvisible = true
          }
          if(type === 1){
            this.titleDialogShowvisible = true
          }
  
        },
  
        titlerejectDialogShowClrB(){
          this.titleDialogShowvisibletitle1 = '审批意见'
          this.fromlabel = '备注：'
          this.placeholderfrom = '请输入意见'
          this.titleDialogShowvisible1 = true
        },
        titlerejectDialogShowClrS(){
          this.titleDialogShowvisibletitle1 = '驳回原因'
          this.fromlabel = '驳回原因：'
          this.placeholderfrom = '请输入驳回原因'
          this.titleDialogShowvisible1 = true
        },
    }
  
  }
  </script>
  
  
  <style scoped lang="less">
  
    .no-click {
        pointer-events: none;
    }
  
    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }
  
    /deep/ .el-form-item__content{
        margin-left: 0 !important;
    }
  
  </style>
  


// WEBPACK FOOTER //
// src/TeacherManagement/theJobTeacher.vue